import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds, MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";

const TITLE = "Kalkulator Perbedaan Antara Dua Tanggal atau Usia";
const DESCRIPTION =
  "Kalkulator ini menghitung periode antara dua tanggal dalam Masehi serta menghitung hari antara dua tanggal dan menentukan waktu yang telah berlalu dan tersisa secara akurat dalam tahun, bulan, dan hari.";
const KEYWORDS =
  "perhitungan perbedaan usia, kalkulator perbedaan usia antara dua orang, kalkulator perbedaan usia, perhitungan perbedaan waktu yang akurat, perbedaan antara dua tanggal Masehi";
const OG_URL = "https://do-calculate.com/calculator/id/gregoriandifferences/";

const GREGORIAN_MONTHS = [
  "Januari", "Februari", "Maret", "April", "Mei", "Juni",
  "Juli", "Agustus", "September", "Oktober", "November", "Desember"
];

function AgeCalculatorGregorian() {
  const [d1, setD1] = useState({ day: "1", month: "1", year: "1990" });
  const [d2, setD2] = useState({ day: new Date().getDate().toString(), month: (new Date().getMonth() + 1).toString(), year: new Date().getFullYear().toString() });
  const [differences, setDifferences] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const calculateDifferences = () => {
    setIsLoading(true);
    const date1 = new Date(parseInt(d1.year), parseInt(d1.month) - 1, parseInt(d1.day));
    const date2 = new Date(parseInt(d2.year), parseInt(d2.month) - 1, parseInt(d2.day));

    if (isNaN(date1.getTime()) || isNaN(date2.getTime())) {
      setError("Harap masukkan tanggal yang valid");
      setDifferences(null);
      setIsLoading(false);
      return;
    }

    let startDate = date1 < date2 ? date1 : date2;
    let endDate = date1 < date2 ? date2 : date1;

    let years = endDate.getFullYear() - startDate.getFullYear();
    let months = endDate.getMonth() - startDate.getMonth();
    let days = endDate.getDate() - startDate.getDate();

    if (days < 0) {
      months--;
      const lastMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
      days += lastMonth.getDate();
    }
    if (months < 0) {
      years--;
      months += 12;
    }

    const totalMilliseconds = endDate - startDate;
    const totalSeconds = Math.floor(totalMilliseconds / 1000);
    const totalMinutes = Math.floor(totalSeconds / 60);
    const totalHours = Math.floor(totalMinutes / 60);
    const totalDays = Math.floor(totalHours / 24);

    setDifferences({
      years, months, days,
      totalDays,
      totalWeeks: Math.floor(totalDays / 7),
      totalMonths: years * 12 + months,
      totalHours,
      totalMinutes,
      totalSeconds,
      startDateStr: startDate.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      endDateStr: endDate.toLocaleDateString("id-ID", { weekday: "long", year: "numeric", month: "long", day: "numeric" }),
      centuryPercentage: ((totalDays / (100 * 365.25)) * 100).toFixed(2),
      solarYears: (totalDays / 365.25).toFixed(2),
      workDays: Math.floor((totalDays / 7) * 5),
    });
    setError(null);
    setIsLoading(false);
  };

  const renderSelectDate = (data, setData, label) => (
    <div className="mb-4">
      <label ><strong>{label}:</strong></label>
      <div className="row">
        <div className="col-md-4">
          <select className="form-control" value={data.day} onChange={(e) => setData({ ...data, day: e.target.value })}>
            {Array.from({ length: 31 }, (_, i) => i + 1).map(d => <option key={d} value={d}>{d}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.month} onChange={(e) => setData({ ...data, month: e.target.value })}>
            {GREGORIAN_MONTHS.map((m, i) => <option key={i + 1} value={i + 1}>{i + 1} - {m}</option>)}
          </select>
        </div>
        <div className="col-md-4">
          <select className="form-control" value={data.year} onChange={(e) => setData({ ...data, year: e.target.value })}>
            {Array.from({ length: 150 }, (_, i) => new Date().getFullYear() + 10 - i).map(y => <option key={y} value={y}>{y}</option>)}
          </select>
        </div>
      </div>
    </div>
  );

  return (
    <div className="ltr" style={{ direction: "rtl", textAlign: "right" }}>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center p-3 rounded">
            <h1 style={{ fontSize: "20px", margin: 0 }}>{TITLE}</h1>
          </div>
          <div className="border border-light mt-3 p-3 bg-white shadow-sm">
            <div>
              <p>
                Kalkulator ini menghitung periode antara dua tanggal baik dalam Hijriah maupun
                Masehi, serta menghitung hari antara dua tanggal menggunakan kalkulator
                hari, dan menentukan waktu yang telah berlalu dan tersisa antara dua tanggal tertentu. 
                "Kalkulator Perbedaan Usia" memungkinkan perhitungan perbedaan antara dua tanggal yang dimasukkan
                dalam tahun, bulan, hari, jam, menit, dan detik. Selain itu,
                perhitungannya juga mencakup perhitungan perbedaan usia, perbedaan antara dua tanggal,
                perhitungan perbedaan antara dua tanggal, dan perbedaan antara dua usia.
              </p>
              <p>
                Gunakan kalkulator ini untuk mencapai akurasi tinggi dalam menghitung perbedaan waktu,
                apakah perbedaan tersebut terkait dengan usia antara dua orang atau antara tanggal
                lahir tertentu. Anda akan mendapatkan hasil yang akurat dan komprehensif yang menunjukkan perbedaannya secara
                detail, memungkinkan Anda untuk lebih memahami waktu dan waktu antara peristiwa atau
                kejadian.
              </p>
              <p>
                Nikmati menentukan perbedaan usia dengan akurat, dan temukan perbedaan waktu antara
                tanggal tertentu, dan gunakan informasi ini secara efektif dalam berbagai
                konteks pribadi dan profesional. Jangan ragu untuk menggunakan alat
                efektif ini untuk mendapatkan analisis waktu yang komprehensif dan akurat.
              </p>
              <br />
            </div>

            <hr />
            <MobileUnderCalAds />
            <div className="calculatorStyle mb-4">
              <div className="p-3 mb-3 bg-success text-white text-center rounded">
                <h2 style={{ fontSize: "18px", margin: 0 }}>Masukkan Tanggal Lahir atau Kejadian</h2>
              </div>

              {renderSelectDate(d1, setD1, "Tanggal Pertama")}
              {renderSelectDate(d2, setD2, "Tanggal Kedua")}

              <div className="text-center mt-4">
                <button className="btn btn-success btn-lg px-5" onClick={calculateDifferences} disabled={isLoading}>
                  {isLoading ? "Menghitung..." : "Hitung Perbedaan Usia"}
                </button>
              </div>

              {error && <div className="alert alert-danger mt-3">{error}</div>}

              {differences && (
                <div className="mt-4 animate__animated animate__fadeIn">
                  <div className="alert alert-success" style={{ backgroundColor: "#d4edda", color: "#155724" }}>
                    <h3 style={{ fontSize: "19px" }}><strong>Hasil Perhitungan Perbedaan Antara Dua Tanggal:</strong></h3>
                    <div className="p-3 bg-white rounded border mt-2">
                      <strong>Perbedaan antara kedua tanggal adalah:</strong>
                      <p style={{ fontSize: "22px", fontWeight: "bold", color: "#28a745", marginTop: "5px" }}>
                        {differences.years} tahun {differences.months} bulan {differences.days} hari
                      </p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Perbedaan Secara Detail</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>✓ Tahun: {differences.years}</li>
                            <li>✓ Bulan: {differences.months}</li>
                            <li>✓ Hari: {differences.days}</li>
                            <li>✓ Jam: 0</li>
                            <li>✓ Menit: 0</li>
                            <li>✓ Detik: 0</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6 mb-3">
                      <div className="card h-100 shadow-sm">
                        <div className="card-header bg-success text-white"><strong>Statistik Total</strong></div>
                        <div className="card-body">
                          <ul className="list-unstyled lh-lg">
                            <li>📅 Total Hari: {differences.totalDays.toLocaleString()} hari</li>
                            <li>📅 Total Minggu: {differences.totalWeeks.toLocaleString()} minggu</li>
                            <li>📅 Total Bulan: {differences.totalMonths.toLocaleString()} bulan</li>
                            <li>⏰ Total Jam: {differences.totalHours.toLocaleString()} jam</li>
                            <li>⏰ Total Menit: {differences.totalMinutes.toLocaleString()} menit</li>
                            <li>⏰ Total Detik: {differences.totalSeconds.toLocaleString()} detik</li>
                            <li>💼 Perkiraan Hari Kerja: {differences.workDays.toLocaleString()} hari</li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="card shadow-sm border-0 bg-light">
                    <div className="card-body">
                      <h4 style={{ fontSize: "17px" }}><strong>Informasi Detail tentang Kedua Tanggal</strong></h4>
                      <p className="mb-1"><strong>Tanggal Pertama:</strong> {differences.startDateStr}</p>
                      <p><strong>Tanggal Kedua:</strong> {differences.endDateStr}</p>
                      <hr />
                      <strong>Periode ini mewakili:</strong>
                      <ul className="mt-2 lh-lg">
                        <li>{differences.centuryPercentage}% dari satu abad (100 tahun)</li>
                        <li>{differences.solarYears} tahun matahari</li>
                        <li>{Math.floor(differences.totalDays / 30)} bulan kira-kira</li>
                      </ul>
                    </div>
                  </div>
                </div>
              )}
            </div>
            <RelatedLinks />
          </div>
        </div>
        <div className="col-md-4">
          <SecondAds />
          <MainCalculatorsList />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                {" "}
                Perbedaan Antara Dua Tanggal dalam Kalender Masehi: Menghitung Perbedaan Usia Antara Dua Orang{" "}
              </div>
              <div className="info-section-body">
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Perbedaan Antara Dua Tanggal dalam Kalender Masehi: Menghitung Perbedaan Usia Antara Dua Orang{" "}
                  </h2>{" "}
                </u>
                <p>
                  Usia adalah aspek penting dalam kehidupan manusia, yang mencerminkan pengalaman dan kematangannya
                  seiring berjalannya waktu. Menghitung perbedaan antara dua tanggal dalam kalender Masehi memerlukan
                  pengetahuan yang akurat tentang tanggal dan kemampuan untuk mengkonversinya menjadi perbedaan waktu yang sederhana.
                  Dalam artikel ini, kita akan melihat bagaimana menghitung perbedaan usia antara
                  dua orang atau antara tanggal tertentu dalam kalender Masehi.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Konsep Dasar Menghitung Perbedaan Usia
                  </h2>{" "}
                </u>
                <p>
                  Menghitung perbedaan usia adalah proses menentukan jumlah tahun, bulan,
                  dan hari yang memisahkan antara dua tanggal tertentu dalam kalender Masehi. Dapat
                  digunakan perhitungan ini dalam banyak konteks seperti menghitung perbedaan usia
                  antara dua orang, atau mengetahui perbedaan tahun antara tanggal penting seperti kelulusan, atau acara
                  lainnya.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Cara Menghitung Perbedaan Usia Antara Tanggal Lahir
                  </h2>{" "}
                </u>
                Untuk menghitung perbedaan usia antara tanggal lahir tertentu dalam kalender Masehi,
                Anda dapat mengikuti langkah-langkah berikut:
                <ul>
                  <li>
                    Menentukan tanggal: Mulailah dengan menentukan tanggal yang ingin Anda hitung perbedaannya.
                  </li>
                  <li>
                    Mengkonversi tanggal menjadi hari: Konversikan setiap tanggal menjadi jumlah
                    hari dengan mudah. Misalnya, Anda dapat mengkonversi setiap tanggal menjadi jumlah
                    hari dari awal kalender.
                  </li>
                  <li>
                    Menghitung perbedaan: Kurangi jumlah hari satu dari yang lain untuk mendapatkan
                    perbedaan usia dalam hari.
                  </li>
                  <li>
                    Mengkonversi perbedaan usia: Perbedaan usia dalam hari dapat dikonversi menjadi
                    bulan atau tahun dengan membagi dengan jumlah hari dalam bulan atau tahun. Sebagai
                    contoh, ada sekitar 30 hari dalam sebulan.
                  </li>
                </ul>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Menggunakan Kalkulator Perbedaan Antara Dua Usia atau Tanggal{" "}
                  </h2>{" "}
                </u>
                <p>
                  Untuk memudahkan proses menghitung perbedaan usia, Anda dapat menggunakan kalkulator perbedaan
                  usia online. Alat-alat ini menawarkan perhitungan cepat dan akurat
                  untuk perbedaan antara tanggal dalam hari, bulan, dan tahun.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Kegunaan Menghitung Perbedaan Antara Dua Usia atau Tanggal{" "}
                  </h2>{" "}
                </u>
                <p>
                  Perhitungan perbedaan usia dapat digunakan dalam banyak konteks seperti menghitung
                  perbedaan usia antara dua orang dalam suatu hubungan, atau untuk menentukan perbedaan tahun antara tanggal
                  penting seperti tanggal pernikahan atau tanggal pindah ke rumah baru. Juga
                  dapat digunakan dalam aspek administrasi dan statistik.
                </p>
                <hr />
                <u>
                  <h2 style={{ fontSize: "16px" }}>
                    {" "}
                    Bagaimana Kalkulator Perbedaan Antara Dua Usia Bekerja{" "}
                  </h2>{" "}
                </u>
                Kalkulator ini menghitung perbedaan usia antara dua tanggal dalam
                kalender Masehi. Jika Anda memasukkan dua tanggal lahir, kalkulator akan mengembalikan
                perbedaan usia di antara keduanya.
                <br />
                Saat menggunakan fungsi ini, tanggal Masehi harus dimasukkan dalam format
                yang benar seperti "YYYY-MM-DD". Jika tanggal yang tidak valid dimasukkan, kalkulator akan menampilkan
                kesalahan dan mengembalikan pesan bahwa tanggal yang valid harus dimasukkan.
                <br />
                Kalkulator akan mengembalikan hasil yang berisi perbedaan antara tanggal yang dimasukkan dalam
                format tahun, bulan, hari, jam, menit, dan detik.
                <br />
              </div>
            </div>
          </div>
          <br />
          <u>
            {" "}
            <h2>Pertanyaan Umum</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa itu perhitungan perbedaan antara dua usia dalam kalender Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Perhitungan perbedaan antara dua usia dalam kalender Masehi adalah proses menentukan perbedaan
                waktu antara tanggal lahir mereka dalam tahun, bulan, dan hari. Ini dilakukan
                biasanya untuk mengetahui perbedaan antara usia orang atau untuk tujuan lain.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bagaimana cara menghitung perbedaan antara dua usia dalam kalender Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Anda dapat menghitung perbedaan antara dua usia dalam kalender Masehi dengan mengikuti langkah-langkah
                berikut:
                <ol>
                  <li>Menentukan tanggal lahir kedua orang.</li>
                  <li>
                    Mengkonversi tanggal tersebut menjadi jumlah hari sejak awal kalender Masehi.
                  </li>
                  <li>Kurangi perbedaan antara hari untuk mendapatkan perbedaan dalam hari.</li>
                  <li>Konversikan perbedaan dalam hari menjadi tahun dan bulan jika Anda mau.</li>
                </ol>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apakah ada kalkulator untuk menghitung perbedaan antara dua usia dalam kalender Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, Anda dapat menggunakan banyak kalkulator perbedaan usia online
                untuk memudahkan proses ini. Alat-alat ini menghitung perbedaan secara akurat dan
                cepat. Cukup masukkan tanggal lahir dan Anda akan mendapatkan perbedaan dalam tahun,
                bulan, dan hari.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Apa pentingnya menghitung perbedaan antara dua usia dalam kalender Masehi?
                </h3>
              </div>
              <div className="info-section-body">
                Menghitung perbedaan antara dua usia dalam kalender Masehi bisa menjadi penting
                untuk banyak konteks seperti mengetahui perbedaan antara usia orang dalam hubungan
                pribadi atau untuk tujuan perencanaan acara dan perayaan khusus. Ini juga digunakan
                dalam banyak aspek administrasi dan statistik.
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Bisakah perbedaan antara dua usia dihitung secara manual?
                </h3>
              </div>
              <div className="info-section-body">
                Ya, perbedaan antara dua usia dalam kalender Masehi dapat dihitung secara manual dengan mengetahui
                tanggal lahir dan menggunakan aturan Masehi yang dikenal. Ini
                membutuhkan sedikit waktu dan usaha, tetapi secara teknis memungkinkan.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default AgeCalculatorGregorian;